import { useLanguage } from "../../../Context/LanguageContext";
import "./LegalPage.css";

// مكوّن عام تُبنى عليه كل الصفحات القانونية - بياخد فقط المحتوى ويعرضه
// بتصميم موحّد، بدل ما نكرر نفس الـ layout في كل صفحة
export default function LegalPage ( { content } )
{
    const { lang } = useLanguage();
    const data = content[ lang ] || content.ar;

    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1 className="legal-title">{ data.title }</h1>
                <p className="legal-updated">{ data.lastUpdated }</p>

                { data.sections.map( ( section, i ) => (
                    <div className="legal-section" key={ i }>
                        <h2>{ section.heading }</h2>
                        { section.paragraphs && section.paragraphs.map( ( p, j ) => (
                            <p key={ j }>{ p }</p>
                        ) ) }
                        { section.list && (
                            <ul>
                                { section.list.map( ( item, k ) => (
                                    <li key={ k }>{ item }</li>
                                ) ) }
                            </ul>
                        ) }
                    </div>
                ) ) }
            </div>
        </div>
    );
}
